import { size } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import { determineProductIdFromBundles } from '../../../../pages/choosable/pages/picker/utils/bundle';
import BundleChosenView from '../../../../pages/choosable/pages/picker/components/join-bar/components/bundle-chosen-view';
import NoBundleChosenView from '../../../../pages/choosable/pages/picker/components/join-bar/components/no-bundle-chosen-view';

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;

type FooterProps = {
  customer: {
    frequency: string;
  };
  effectiveDate?: string;
  prices?: {};
  selectedBundles: string[];
};

const Footer = ({ customer, effectiveDate, prices, selectedBundles }: FooterProps) => {
  const isBundleChosen = size(selectedBundles) > 0;
  const productId = determineProductIdFromBundles(selectedBundles);

  return (
    <FooterWrapper>
      {isBundleChosen ? (
        <BundleChosenView
          {...{
            customer,
            effectiveDate,
            isCondensed: true,
            prices,
            productId,
          }}
        />
      ) : (
        <NoBundleChosenView isCondensed />
      )}
    </FooterWrapper>
  );
};

Footer.defaultProps = {
  effectiveDate: null,
  prices: null,
};

export default Footer;
